<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <TheTemplateH v-if="showTransacntionType()" heading="ポイント詳細">
          <template #title>付与基準達成</template>
          <template #header-label>
            <SmallText>
              {{ investedId.label }}&ensp;{{ investedId.id }}</SmallText
            >
          </template>
          <template #contents>
            <div class="p-the-h03">
              <TheHDetail
                :image="true"
                :rounded-image="true"
                :usage-point="usagePoint"
                :max-width="false"
              >
                <template #image>
                  <IconInvestedRounded
                    :icon-size="iconSize"
                    :bg-color="colorCode"
                    icon-color="#ffffff"
                    :type="investedDetails.image_type"
                  />
                </template>
                <template #header>
                  <div class="p-the-h03-detail">
                    <SmallText>
                      {{ investedDetails.investment_criteria_id.label }}&ensp;{{
                        investedDetails.investment_criteria_id.id
                      }}
                    </SmallText>

                    <HContainer margin-size="xs">
                      <template #content>
                        <span class="p-the-h03-detail__text" data-translate-skip>
                          {{ investedDetails.invested_name }}
                        </span>
                      </template>
                    </HContainer>
                  </div>
                </template>

                <template #body>
                  <HContainer>
                    <template #content>
                      <SmallText>摘要</SmallText>
                      <span class="p-the-h03__text" data-translate-skip>
                        {{ investedDetails.description }}
                      </span>
                    </template>
                  </HContainer>

                  <HContainer>
                    <template #content>
                      <HSpecColumnList
                        :list-item="columnList"
                        column-size="m"
                      />
                    </template>
                  </HContainer>
                </template>

                <template #label>
                  <TextLabel
                    v-if="point.label"
                    :color="{ border: '#9e9e9e', content: '#ffffff' }"
                    :reverse="true"
                  >
                    {{ point.label }}
                  </TextLabel>
                </template>

                <template v-if="point.expiration" #point>
                  <SmallText
                    v-for="({ label, date }, key) in point.expiration"
                    :key="key"
                    >{{ label }}&ensp;{{
                      date == "Invalid Date" ? "--" : date
                    }}</SmallText
                  >
                </template>
              </TheHDetail>
            </div>
          </template>
        </TheTemplateH>
        <TheTemplateH v-if="transaction_type === 50" heading="ポイント詳細">
          <template #title>{{ titleThanksgiving }}</template>

          <template #header-label>
            <!-- Approved icon Displayed only when the administrator has approved it Hide for corporations with the approval function OFF -->
            <TextLabel
              v-if="approvalEnabled"
              :color="{ border: '#616161', content: '#ffffff' }"
              :reverse="false"
              >{{ approvedLabel }}</TextLabel
            >
          </template>
          <template #contents>
            <div class="p-the-h03">
              <TheHDetail :image="true" :usage-point="givePoint">
                <template #image>
                  <IconUserImage :size="userImageSize">
                    <img :src="image" alt />
                  </IconUserImage>
                </template>

                <template #header>
                  <div class="p-the-h03-detail">
                    <SmallText>
                      {{ giveData.give_details.give_id.label }}
                      &ensp;{{ giveData.give_details.give_id.id }}
                    </SmallText>

                    <HContainer margin-size="xs">
                      <template #content>
                        <span class="p-the-h03-detail__text" data-translate-skip>
                          {{ giveDetails.give_to }}
                        </span>
                      </template>
                    </HContainer>

                    <HContainer margin-size="xs">
                      <template #content>
                        <SmallText data-translate-skip>{{
                          giveDetails.group_name
                        }}</SmallText>
                      </template>
                    </HContainer>

                    <!-- DX_IC-628 グループコード表示追加 -->
                    <HContainer margin-size="xs">
                      <template #content>
                        <SmallText>ID：{{ giveDetails.group_code }}</SmallText>
                      </template>
                    </HContainer>
                  </div>
                </template>

                <template #body>
                  <HContainer margin-size="m">
                    <template #content>
                      <SmallText>タイトル</SmallText>
                      <span class="p-the-h03__text" data-translate-skip>{{
                        message.title
                      }}</span>
                    </template>
                  </HContainer>

                  <HContainer margin-size="m">
                    <template #content>
                      <SmallText>メッセージ</SmallText>
                      <p class="p-the-h03__text" data-translate-skip>
                        {{ message.text }}
                      </p>
                    </template>
                  </HContainer>

                  <HContainer margin-size="m">
                    <template v-if="messsageThreadEnabled == 1" #content>
                      <ButtonMain
                        tag="a"
                        kind="secondary"
                        :reverse="true"
                        :href="message.url"
                      >
                        メッセージスレッドを見る
                      </ButtonMain>
                    </template>
                  </HContainer>

                  <HContainer margin-size="l">
                    <template #content>
                      <SmallText>{{ giveDetails.dateLabel }}</SmallText>
                      <p class="p-the-h03__text">
                        {{ giveDetails.date }}
                      </p>
                    </template>
                  </HContainer>
                </template>

                <template v-if="pointThanksgiving.expiration" #point>
                  <SmallText
                    v-for="({ label, date },
                    key) in pointThanksgiving.expiration"
                    :key="key"
                  >
                    {{ label }}&ensp;{{ date }}
                  </SmallText>
                </template>
              </TheHDetail>
            </div>
          </template>
        </TheTemplateH>
      </div>
    </div>
    <FloatingGivePointButton />
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import TheHDetail from "@/general/components/pages/parts/PointHistoryList/layout/TheHDetail.vue";
import TheTemplateH from "@/general/components/templates/TheTemplateH.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HSpecColumnList from "@/general/components/pages/parts/PointHistoryList/HSpecColumnList.vue";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { formatUTCDate } from "@/common/assets/js/utils/dateFormat";
import { getExpirePointDetails } from "@/general/store/api";
import {
  getQueryString,
  setQueryString
} from "@/common/assets/js/utils/queryParams";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import HGivePointPageIcon from "@/general/components/pages/parts/PointHistoryList/page-of-give-the-point/HGivePointPageIcon.vue";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import { UserInfo } from "@/general/store/models";
import { getApprovalStatusLabel } from "@/common/assets/js/utils/types";
import {
  getThanksPointName,
  getThanksOnlyPointName
} from "@/common/assets/js/utils/pointName";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Options({
  name: "ExpiringPointDetails",
  components: {
    TheBreadcrumb,
    TheHDetail,
    IconInvestedRounded,
    TextLabel,
    SmallText,
    TheTemplateH,
    HContainer,
    HSpecColumnList,
    ButtonMain,
    HGivePointPageIcon,
    IconUserImage
  }
})
export default class ExpiringPointDetails extends Vue {
  investedData: any = {};
  userInfo: UserInfo;
  giveData: any = {};
  isTransactionType = false;

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return commons?.colorCode;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }
  get isSpScreenWidth() {
    return globals?.isSpScreenWidth;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  async setPageData() {
    const breadcrumb = [
      {
        text: "",
        url: CONST_DATA.SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: "ポイント確認",
        url: `${CONST_DATA.SITE_MAP.POINT_CONFIRMATION}?${getQueryString({
          ...this.params,
          id: undefined
        })}`,

        pageType: "lower"
      },
      {
        text: "ポイント有効期限一覧",
        url:
          `${CONST_DATA.SITE_MAP.EXPIRING_POINTS}?` +
          getQueryString({ ...this.params, id: undefined }),
        pageType: "lower"
      },
      {
        text: "ポイント詳細",
        url: "",
        pageType: "lower"
      }
    ];

    await commons.getBreadcrumb(breadcrumb);
  }

  params = {
    id: "",
    transaction_type: "",
    transaction_direction: "",
    filter_position: "",
    refine_position: "",
    ordering: "",
    page: "1",
    search: ""
  };

  expiringPointId: any = false;
  expiry_point_type = "";
  transaction_type = 0;

  mounte() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.expiringPointId = urlParams.get("id")
      ? parseInt(urlParams.get("id") as string)
      : "";
    this.expiry_point_type = "expiring";

    const queries = [
      { k: "id" },
      { k: "transaction_type" },
      { k: "transaction_direction" },
      { k: "filter_position" },
      { k: "refine_position" },
      { k: "ordering", v: "-created_at" },
      { k: "page", v: 1 },
      { k: "search" }
    ];
    this.params = setQueryString(this.params, queries);
    await this.setPageData();

    this.userInfo = await this.getUserDetails();
    await this.retrieveGrantPointDetails();
  }

  async getUserDetails(): Promise<UserInfo> {
    return auth.user;
  }

  async retrieveGrantPointDetails() {
    const response = await getExpirePointDetails(
      this.expiry_point_type,
      this.expiringPointId
    );

    if (response?.transaction_type === undefined) {
      window.location.href = CONST_DATA.SITE_MAP.EXPIRING_POINTS;
    }

    this.transaction_type = response.transaction_type;
    if (
      this.transaction_type === 20 ||
      this.transaction_type === 40 ||
      this.transaction_type === 80 ||
      this.transaction_type === 90 ||
      this.transaction_type === 100
    ) {
      const details = response.transaction_details;
      const grant_criteria = details.grant_criteria;
      const pointAddition =
        this.userInfo?.user_id === details.from_user.id ? false : true;

      const point = {
        usage: response?.remaining_points,
        sign: pointAddition,
        label: "",
        expiration: [
          {
            label: "有効期限",
            date: formatUTCDate(details?.expire)
          }
        ]
      };

      if (details?.grant_type === 30) {
        point.label = this.thanksOnlyPointName;
        point.expiration.push({
          label: "贈与期限",
          date: formatUTCDate(details?.thanks_exclusive_deadline)
        });
      }
      // DX_IC-942
      const invested_details = {
        image_type: grant_criteria?.grant_criteria_icon_id,
        investment_criteria_id: {
          label: "付与基準ID",
          id: grant_criteria?.pk == 0 ? "" : grant_criteria?.pk
        },
        invested_name: details?.title,
        description: details?.text,
        date: formatUTCDate(details?.authorize_date),
        sender_name: response?.user_name == null ? "－ " : response?.user_name,
        sender_group:
          response?.group_name == null ? "－ " : response?.group_name
      };

      this.investedData = {
        title: details.title, // "付与基準達成",
        invested_id: {
          label: "付与ID",
          id: details?.pk
        },
        invested_details,
        point
      };
    } else if (this.transaction_type === 50) {
      const details = response.transaction_details;
      const { from_user, to_user } = details;

      const state = this.userInfo?.user_id === from_user.id ? "given" : "give";
      const added = state === "give" ? true : false;
      const user = state === "give" ? from_user : to_user;
      const title =
        state === "give"
          ? this.thanksPointName + "受贈"
          : this.thanksPointName + "贈与";

      const approved = response?.status_code === 20 ? true : false; //TODO move to constants
      const give_to = from_user?.user_name;

      // DX_IC-942
      this.giveData = {
        title,
        give_details: {
          image: user.id == 0 ? "" : user?.user_image,
          give_id: {
            label: "贈与ID",
            id: response?.transaction_details.pk
          },
          give_to,
          group_name: user?.group_name,
          // DX_IC-628 グループコード表示追加
          group_code: user?.group_code,
          message: {
            title: response?.transaction_details.title,
            text: response?.transaction_details.message,
            url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${response?.transaction_details?.pk}`
          },
          dateLabel: state === "given" ? "贈与日" : "受贈日",
          date: this.$dayjs
            .utc(response?.transaction_details.created_at)
            .locale("ja")
            .format("YYYY/MM/DD")
        },
        approved,
        approvedStatus: details.status,
        point: {
          state,
          added,
          give: response?.remaining_points,
          expiration: [
            {
              label: "有効期限",
              date: formatUTCDate(response?.expiry_date)
            }
          ]
        }
      };
      // DX_IC-942
      const messageArticleDetail = {
        id: user?.id,
        name: give_to,
        date: response?.transaction_details.created_at,
        content: response?.transaction_details.message,
        url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${response?.transaction_details?.pk}`,
        icon: {
          original: "",
          large: "",
          medium: user?.user_image,
          small: ""
        },
        point: {
          total: response?.points,
          pointAddition: false,
          state
        },
        unread:
          response?.transaction_details.has_read === false && state !== "give"
            ? true
            : false
      };

      LocalStorage.setItem(
        "messageCardDetails",
        JSON.stringify(messageArticleDetail)
      );
    }
  }

  showTransacntionType() {
    if (
      this.transaction_type === 20 ||
      this.transaction_type === 40 ||
      this.transaction_type === 80 ||
      this.transaction_type === 90 ||
      this.transaction_type === 100
    ) {
      return (this.isTransactionType = true);
    }
  }

  get columnList() {
    const investedDetails = this.investedData.invested_details;
    const columnList = [
      {
        label: "付与日",
        detail: [investedDetails.date]
      }
    ];

    return columnList;
  }

  get title() {
    return this.investedData.title; // "付与基準達成";
  }

  get investedId() {
    return this.investedData ? this.investedData.invested_id : {};
  }
  get investedDetails() {
    return this.investedData.invested_details;
  }
  get point() {
    return this.investedData && this.investedData.point
      ? this.investedData.point
      : {};
  }
  get usagePoint() {
    return this.investedData && this.investedData.point
      ? {
          point: this.investedData.point.usage,
          sign: this.investedData.point.sign
        }
      : {};
  }

  get iconSize() {
    return this.isSpScreenWidth ? 72 : 135;
  }

  // Details Thanksgiving - gaining
  get givePoint() {
    return {
      point: this.giveData.point.give,
      sign: this.giveData.point.added
    };
  }

  get userIcon() {
    return this.userInfo?.avatar;
  }

  get approvedLabel() {
    const { approved, approvedStatus } = this.giveData;
    if (typeof approved === "undefined") return -1;
    return getApprovalStatusLabel(approvedStatus);
  }

  get titleThanksgiving() {
    return this.giveData.title;
  }

  get giveId() {
    return this.giveData.give_details.give_id;
  }

  get giveDetails() {
    return this.giveData.give_details;
  }

  get image() {
    return this.giveData.give_details.image;
  }

  get message() {
    return this.giveData.give_details.message;
  }

  get approved() {
    return this.giveData.approved;
  }
  get pointThanksgiving() {
    return this.giveData.point;
  }
  get userImageSize() {
    const { isSpScreenWidth } = globals;
    return isSpScreenWidth ? 72 : 138;
  }
  get approvalEnabled() {
    return auth.user?.thanks_point_approval_enabled;
  }
  get messsageThreadEnabled() {
    return auth.user?.thread_enabled;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get thanksOnlyPointName() {
    return getThanksOnlyPointName(
      CONST_DATA.POINT_NAME.THANKS_ONLY_POINT_DEFAULT_NAME2
    );
  }
}
</script>
